import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonListbox } from './Listbox.definition';
import { chameleonListboxItem } from './ListboxItem/ListboxItem.definition';
import { chameleonInteractiveSubItem } from './InteractiveSubItem/InteractiveSubItem.definition';
provideChameleonDesignSystem().register(chameleonListbox(), chameleonListboxItem(), chameleonInteractiveSubItem());
